// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		if(document.getElementById('header').classList.contains('no-hero') || document.getElementById('gallery') || document.getElementById('attractions')){
			document.getElementById('header').classList.add('scroll');
			let logoUrl = '/assets/svg/logo-scroll.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
		} else{
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}
		
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	
	//// Forms animation for labels   ----------------------------------------------------------------
	//Email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	// BURGER MENU NAVIGATION:

		// BURGUER MENU DESKTOP ----------------------------------------------------------------

		const menuBtn = document.getElementById('menu-btn');
		const navigation = document.querySelector('.navigation');
		const closeMenuBtn = document.querySelector('.js-close-menu');

		menuBtn.addEventListener('click', function(event) {
			event.preventDefault();
			navigation.classList.add('open');
		});

		closeMenuBtn.addEventListener('click', function(event) {
			event.preventDefault();
			navigation.classList.remove('open');
		});

	// BURGUER MENU MOBILE ----------------------------------------------------------------

	const burgerMenuBtn = document.querySelector("#js-burgerMenuBtn");
	const burgerMenuContainer = document.querySelector("#js-menuContainer")
	const closeMenu = document.querySelector(".js-burger-close");
	
	//Open Menu

	if(burgerMenuBtn){
		burgerMenuBtn.addEventListener('click', function (e) {
			e.preventDefault();
			burgerMenuContainer.classList.add("open");
			document.body.classList.add("no-scroll");
		});
	}
	
	if(closeMenu){
		closeMenu.addEventListener('click', () => {
			burgerMenuContainer.classList.remove("open");
			document.body.classList.remove("no-scroll");
		});
	}

	// SHOW SUBMENU FUNCTION: 

	const submenuToShow = (linksSelector, linkSubmenu) => {
		let navLinks = document.querySelectorAll(linksSelector); 
		let submenu_active = document.querySelectorAll(linkSubmenu); 

		navLinks.forEach(link => {
			const parent = link.parentNode;
			let submenu = parent.querySelector('.submenu');
			link.addEventListener('click', (e) => {
				link.classList.toggle('active');
				submenu.classList.toggle('active');
			});
		});
		submenu_active.forEach(sub => {
			if (sub.classList.contains('active')) {
				if (window.screen.width > 640) {
					let selectedLink = sub.parentNode.parentNode.parentNode.children[0];
					selectedLink.classList.add('selected');
				}else{
					let selectedLink = sub.parentNode.parentNode.parentNode.parentNode.children[0];
					selectedLink.classList.add('selected');
				}
			}

		})
	}

	if (window.screen.width > 640) {
		submenuToShow('#primary-nav li a', '.submenu li a');
	} else {
		submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
	}

	document.addEventListener('DOMContentLoaded', function() {
		const leftTitles = document.querySelectorAll('.accordion-rooms__left .item');
		const rightTitles = document.querySelectorAll('.accordion-rooms__right .js-accordion-rooms-title');
		const rightItem = document.querySelectorAll('.accordion-rooms__right .item');

		if(rightItem[0]){
			rightItem[0].classList.add('active');
		}
	

		function removeActiveClassFromRightTitles() {
			if (rightTitles.length > 0) {
				rightTitles.forEach(function(rightTitle) {
					rightTitle.classList.remove('active');
				});
			}
		}

		function setActiveToFirstRightTitle() {
			if (rightTitles.length > 0) {
				rightTitles[0].classList.add('active');
			}
		}

		function setActiveToFirstLeftTitle() {
			if (leftTitles.length > 0) {
				leftTitles[0].classList.add('active');
			}
		}

		function addActiveToClosestItem(element) {
			if (element) {
				const clickedItem = element.closest('.item');
				if (clickedItem) {
					const siblings = clickedItem.parentNode.querySelectorAll('.item');
					siblings.forEach(function(sibling) {
						if (sibling !== clickedItem) {
							sibling.classList.remove('active');
						}
					});
					clickedItem.classList.toggle('active');
				}
			}
		}

		setActiveToFirstRightTitle();
		setActiveToFirstLeftTitle();

		rightTitles.forEach(function(rightTitle, index) {
			rightTitle.addEventListener('click', function() {
				removeActiveClassFromRightTitles();

				const clickedIndex = index;

				rightTitle.classList.add('active');

				if (leftTitles.length > 0) {
					leftTitles.forEach(function(leftTitle) {
						leftTitle.classList.remove('active');
					});

					if (leftTitles[clickedIndex]) {
						leftTitles[clickedIndex].classList.add('active');
					}
				}

				addActiveToClosestItem(rightTitle);
			});
		});

		if (window.screen.width > 640) {

			// Primary navigation numbers ****************************************************************
			const liElements = document.querySelectorAll('#privary-navigation li');
			let navCounter = 1;
			
			liElements.forEach(function(li) {
				if (!li.parentElement.classList.contains('privary-navigation__submenu')) {
					let textNode = document.createElement('span');
					textNode.innerHTML = '<span class="number">0' + navCounter + '</span>';
					li.querySelector('a').insertBefore(textNode, li.querySelector('a').firstChild);
					navCounter++;
				}
			});
		
		}else{

			// Primary navigation numbers mobile ****************************************************************
			const liElements = document.querySelectorAll('.mobileMenu__nav li');
			let navCounter = 1;

			liElements.forEach(function(li) {
				if (!li.parentElement.classList.contains('submenu')) {
					let textNode = document.createElement('span');
					textNode.innerHTML = '<span class="number">0' + navCounter + '</span>';
					li.querySelector('a').insertBefore(textNode, li.querySelector('a').firstChild);
					navCounter++;
				}
			});
		}
	
	

	});


	// MENU TABS ----------------------------------------------------------

	function filterTabs(linksSelector, contentsSelector) {
		let links = document.querySelectorAll(linksSelector);
		let contents = document.querySelectorAll(contentsSelector);
		if (links.length !== 0 && contents.length !== 0) {
		links[0].classList.add('active');
		contents[0].classList.add('active');
		}
	
		links.forEach((link) => {
		link.addEventListener('click', () => {
			links.forEach((allLinks) => {
			allLinks.classList.remove('active');
			});
			link.classList.add('active');
			contents.forEach((content) => {
			let contentTag = content.getAttribute('data-tag');
			let linkTag = link.getAttribute('data-tag');
			content.classList.remove('active');
				if (linkTag === contentTag) {
					content.classList.add('active');
				}
			});
		});
		});
	}
	
	filterTabs('.js-menu-tab', '.js-menu-content');


	// SELECT MOBILE

	function filterSelect(selectSelector, selectSelectorOption,contentsSelector) {
		let select = document.querySelector(selectSelector);
		let links = document.querySelectorAll(selectSelectorOption)
		let contents = document.querySelectorAll(contentsSelector);
		if (links.length !== 0 && contents.length !== 0) {
			links[0].classList.add('active');
			contents[0].classList.add('active');
		}
		if (select && contents.length !== 0) {
		  select.addEventListener('change', () => {
			let selectedValue = select.value;
			contents.forEach((content) => {
			  let contentTag = content.getAttribute('data-tag');
			  if (contentTag === selectedValue) {
				content.classList.add('active');
			  } else {
				content.classList.remove('active');
			  }
			});
		  });
		}
	  }
	  
	  filterSelect('.js-menu-select','.js-menu-select option', '.js-menu-content');

	// INTRO CONTENT BTN ************************************************
	// Get all elements with class .intro-content to check if they contain a link with class .btn

	function assignBtnBlockClass() {
		let introContents = document.querySelectorAll('.intro-content');
		
		introContents.forEach(function(introContent) {
			let paragraphs = introContent.getElementsByTagName('p');
			for (let i = 0; i < paragraphs.length; i++) {
				let links = paragraphs[i].getElementsByTagName('a');
				for (let j = 0; j < links.length; j++) {
					if (links[j].classList.contains('btn')) {
						paragraphs[i].classList.add('btn-block');
					}
				}
			}
		});
	}
	
	assignBtnBlockClass();
	
	let buttonAttractions = document.querySelector('.attractions-filter__reset button');

	if(buttonAttractions){
		buttonAttractions.classList.add('btn-dark');
	}

	let buttonContactUs = document.querySelector('#form-image .form-module-wrapper .form-module__submit button');

	if(buttonContactUs){
		buttonContactUs.classList.add('btn-dark');
	}

	/*let buttonFooter= document.querySelector('.footer .footer__two form .signup-btn');

	if(buttonFooter){
		buttonFooter.classList.add('btn');
		buttonFooter.classList.add('btn-ligth');
	}*/


})();




function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			document.getElementById('top-content').classList.add('scroll');
			let logoUrl = '/assets/svg/logo-scroll.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)

		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			document.getElementById('top-content').classList.remove('scroll');
			let logoUrl = '/assets/svg/logo.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)

		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

